import { render, staticRenderFns } from "./page-title.vue?vue&type=template&id=a9af6538&scoped=true"
import script from "./page-title.ts?vue&type=script&lang=ts&external"
export * from "./page-title.ts?vue&type=script&lang=ts&external"
import style0 from "./page-title.less?vue&type=style&index=0&id=a9af6538&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9af6538",
  null
  
)

export default component.exports